import { Row } from 'antd';
import React from 'react';

import { SearchInput } from './components/SearchInput';
import { StatusRadioGroup } from './components/StatusRadioGroup';
import { TableComponent } from './components/table';
import { ButtonAdd } from './components/table/TableButtonAdd';

import { TopToolBox } from '../../container/ecommerce/Style';
import { Main, TableWrapper } from '../../container/styled';
import { ThemeLayout } from '../../layout/themeLayout';

import { Cards } from '../../components/cards/frame/cards-frame';
import { PageHeader } from '../../components/page-headers/page-headers';

import { useFetch } from '../../hooks/useFetch';
import { IFetchProps } from './types';

export function Usuarios() {
  const {
    isFetching,
    dataFetch,
    setSearch,
    setStatus,
    refetch,
    currentPage,
    itensPerPage,
    setCurrentPage,
    setColumnOrdenation,
    setItensPerPage,
    totalItens,
  } = useFetch<IFetchProps>({ baseUrl: 'users' });

  return (
    <ThemeLayout>
      <PageHeader ghost title="Usuarios" />

      <Main>
        <Cards headless>
          <TopToolBox>
            <Row gutter={15} className="justify-content-center">
              <SearchInput handleSearch={setSearch} />
              <StatusRadioGroup setStatus={setStatus} />
              <ButtonAdd refetch={refetch} />
            </Row>
          </TopToolBox>

          <TableWrapper className="table-order table-responsive">
            <TableComponent
              setCurrentPage={setCurrentPage}
              setColumnOrdenation={setColumnOrdenation}
              currentPage={currentPage}
              refetch={refetch}
              isLoading={isFetching}
              dataFetch={dataFetch}
              totalItens={totalItens}
              itensPerPage={itensPerPage}
              setItensPerPage={setItensPerPage}
            />
          </TableWrapper>
        </Cards>
      </Main>
    </ThemeLayout>
  );
}
